import { GET_QUALIFICATION_CONFIG_BY_FORMID } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_QUALIFICATION_CONFIG_BY_FORMID:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getQualificationConfigurationByFormId.js